export enum PriceTicket {
  Ticket = 1,
  RegistrationFee = 2,
  NoFee = 3
}
